import React from "react";
import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export function Reveal({ children, className, delay = 0, y = 40, as = "div" }) {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.85, delay, ease }}
    >
      {children}
    </M>
  );
}

export function SectionLabel({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.34em] text-gold/80 ${className}`}>
      <span className="h-px w-8 bg-gold/60" />
      {children}
    </span>
  );
}
